import styles from "./Footer.module.scss";
import { FaYoutube, FaInstagram, FaFacebook } from "react-icons/fa";
import Button from "./Button";
const Footer = () => {
	return (
		<footer className={styles.footer}>
			<div className="content">
				<div className={styles.socials}>
					<Button
						target="_blank"
						href="https://www.youtube.com/channel/UCmWvLESxxWW_r7IcMfBK6gA"
					>
						<FaYoutube />
					</Button>
					<Button target="_blank" href="https://www.instagram.com/csevast/">
						<FaInstagram />
					</Button>
					<Button target="_blank" href="https://www.facebook.com/CSEVASTIANS">
						<FaFacebook />
					</Button>
				</div>
				<p>Designed by @aadithyen</p>
			</div>
		</footer>
	);
};

export default Footer;
